export default {
  drawAreaGkPlan(currentMap) {
    let bkData = JSON.parse(sessionStorage.getItem("xfsbk_data"));
    console.log("板块规控及重要规划", bkData);
    let dots = bkData.center.split("|");
    currentMap.setCenter(dots);
    dots = bkData.dots.split("-").map((x) => {
      return x.split("|");
    });
    let polygon = new AMap.Polygon({
      path: dots,
      fillOpacity: 0,
      strokeWeight: 5,
      strokeOpacity: 1,
      strokeColor: "#333333",
    });
    currentMap.add(polygon);
    currentMap.setFitView([polygon], false, [0, 0, 0, 0]);
    let cells = bkData && bkData.cells;
    if (cells) {
      for (let index = 0; index < cells.length; index++) {
        const element = cells[index];
        dots = element.dots.split("-").map((x) => {
          return x.split("|");
        });
        polygon = new AMap.Polygon({
          path: dots,
          strokeWeight: 5,
          strokeOpacity: 1,
          strokeColor: "transparent",
          fillColor: element.type.slice(0, 7), // 填充色
          fillOpacity: 0.8, // 填充透明度
        });
        currentMap.add(polygon);
        currentMap.setFitView([polygon], false, [0, 0, 0, 0]);
      }
    }
    currentMap.setZoom(14);
  },
  // 板块及规划
  drawAreaPlanImage() {
    let that = this;
    console.log(that.areaIdList);
    let currentMap = this.currentMap;
    if (!currentMap || !currentMap.remove) {
      console.log("err currentMap");
      return;
    }
    currentMap.remove(that.showedLandImages);
    that.$axios
      .post(that.$url_prefix + "getAreaPlanImage", {
        areas: this.areaIdList,
      })
      .then((res) => {
        let showedLandImages = [];
        let planList = res.data.data;
        for (let i = 0; i < planList.length; i++) {
          let temp = planList[i];
          if (!temp.image) {
            continue;
          }
          let layer = new AMap.ImageLayer({
            url: temp.image,
            bounds: new AMap.Bounds(
              temp.southwest.split("|"),
              temp.northeast.split("|")
            ),
            zooms: [12, 18],
            opacity: 0.7,
            map: currentMap,
            zIndex: 110,
          });
          showedLandImages.push(layer);
        }
        that.$message({
          type: "success",
          message: "找到" + showedLandImages.length + "个规划图",
        });
        that.showedLandImages = showedLandImages;
        if (showedLandImages.length > 0) {
          that.center = planList[0].center.split("|");
          that.zoom = 15;
        }
      })
      .catch((res) => {
        console.log("query area fail", res);
      });
  },
  drawAreaPlanCell() {
    let that = this;
    let currentMap = this.currentMap;
    if (this.areaIdList.length) {
      this.drawLandPlan(currentMap, "", this.areaIdList);
    }
  },
  drawAreaWithPlan(currentMap) {
    let that = this;
    that.$axios
      .get(that.$url_prefix + "areaAndLandPlan")
      .then((res) => {
        console.log("planList", res.data.planList);
        let planList = res.data.planList;
        for (let i = 0, len = 3; i < len; i++) {
          let land = planList[i];
          let cells = land.cells;
          for (let k = 0; k < cells.length; k++) {
            let cell = cells[k];
            if (!cell.dots) {
              continue;
            }
            let dots = cell.dots.split("-").map((x) => {
              return x.split("|");
            });
            let type = cell.type;
            let fillColor = "#EE82EE";
            if (type.includes("A")) {
              fillColor = "#708090";
            } else if (type.includes("B")) {
              fillColor = "#32CD32";
            } else if (type.includes("C")) {
              fillColor = "#C1474B";
            } else if (type.includes("R")) {
              fillColor = "#DDD54E";
            } else if (type.includes("M")) {
              fillColor = "#D29E8D";
            } else if (type.includes("G")) {
              fillColor = "#54A440";
            }
            let polygon = new AMap.Polygon({
              path: dots,

              fillOpacity: 0.6,
              fillColor: fillColor,

              strokeWeight: 0,
              strokeColor: "transparent",
            });
            currentMap.add(polygon);
          }
        }
      })
      .catch((res) => {
        console.log("query area fail", res);
      });
  },
  drawLandPlan(currentMap, lnglat, areaIds) {
    let that = this;
    console.log("drawLandPlan");
    if (!currentMap || !currentMap.remove) {
      console.log("err currentMap");
      return;
    }
    that.$open();
    currentMap.remove(that.showedCells);
    that.$axios
      .post(that.$url_prefix + "getCellsByRadius", {
        lnglat: lnglat || "",
        areaIds: areaIds || "",
      })
      .then((res) => {
        that.$close();
        let cells = res.data.data;
        if (cells.length > 0) {
          let showedCells = [];
          for (let k = 0; k < cells.length; k++) {
            let cell = cells[k];
            if (!cell.dots) {
              continue;
            }
            let dots = cell.dots.split("-").map((x) => {
              return x.split("|");
            });
            let type = cell.type;
            let fillColor = "#000000";
            if (type.includes("A") || type.includes("R22")) {
              fillColor = "#ec0bf4";
            } else if (type.includes("B") || type.includes("C")) {
              fillColor = "#ef1010";
            } else if (type.includes("R")) {
              fillColor = "#fdfa04";
            } else if (type.includes("M")) {
              fillColor = "#ff7800";
            } else if (type.includes("G")) {
              fillColor = "#24f808";
            } else if (type.includes("U")) {
              fillColor = "#0656f9";
            } else if (type.includes("E")) {
              fillColor = "#08f8ea";
            }
            let polygon = new AMap.Polygon({
              zIndex: 800,
              pid: cell.plan_id,
              path: dots,

              fillOpacity: 0.6,
              fillColor: fillColor,

              strokeWeight: 0,
              strokeColor: "transparent",
            });
            polygon.on("rightclick", function (e) {
              let routeData = that.$router.resolve({
                path: "drawLand",
                query: {
                  id: e.target.w.pid,
                },
              });
              window.open(routeData.href, "_blank");
            });
            currentMap.add(polygon);
            showedCells.push(polygon);
          }
          that.showedCells = showedCells;
          alert("等待加载" + cells.length + "个地块");
        } else {
          that.$message.error("周边无地块");
        }
        console.log("over");
      })
      .catch((err) => {
        that.$close();
        console.log("err", err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindPlan.js